import { styled } from "goober";
import { Box } from "../Box";
import { Button } from "../Button";
import { Input } from "../Input";
import { NoteTextarea } from "../NoteTextarea";
import { SettingsCard as Card, SettingsHeading } from "../SettingsCard";
import { Text } from "../Text";

const Header = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export type SkillForm = {
  name: string;
  description: string;
  instructions: string;
  enabled: boolean;
};

type Props = {
  form: SkillForm;
  onEditFile: () => void;
  readOnly: boolean;
  onRename?: (name: string) => Promise<boolean>;
};

export function SettingsTab({ form, onEditFile, readOnly, onRename }: Props) {
  return (
    <Card>
      <Header>
        <SettingsHeading>
          <Text variant="text-regular-md">Skill</Text>
          <Text variant="text-small" color="var(--text-secondary)">
            How this skill appears to the AI.
          </Text>
        </SettingsHeading>
        <Button variant="subtle" onClick={onEditFile}>
          {readOnly ? "View file" : "Edit file"}
        </Button>
      </Header>
      <Box>
        <Box horizontal={8} vertical={10}>
          <Text variant="text-small-md" color="var(--text-primary)">
            Name
          </Text>
        </Box>
        <Input
          key={form.name}
          defaultValue={form.name}
          disabled={!onRename}
          onBlur={async (event) => {
            const input = event.currentTarget;
            const name = input.value.trim();
            input.value = name;
            if (!onRename || name === form.name) return;
            let saved = false;
            try {
              saved = await onRename(name);
            } catch {
              saved = false;
            }
            if (!saved && input.value === name) input.value = form.name;
          }}
          placeholder="my-skill"
          style={{ width: "100%", minWidth: 0 }}
        />
      </Box>
      <Box>
        <Box horizontal={8} vertical={10}>
          <Text variant="text-small-md" color="var(--text-primary)">
            Description
          </Text>
        </Box>
        <NoteTextarea
          value={form.description}
          disabled
          placeholder="When should the AI reach for this skill?"
        />
      </Box>
    </Card>
  );
}
